import React, { useState, useEffect } from 'react'
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../assets/images/Icons/calendarIcon.svg";
import DownArrow from "../../../../../src/assets/images/Icons/icons/down_arrow.svg";
import UpArrow from "../../../../../src/assets/images/Icons/icons/up_arrow.svg";
import { makeAjax, respStatus, url, showMessage, gameList } from '../../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { setTotalNoResult } from "../../../../redux/actions";
import { withTranslation } from "react-i18next";
import { formatPrice, formatPricewithdecimal } from "../../../NumberFormat";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaCalendar } from "react-icons/fa";

function BonusReferral(props) {

  const dispatch = useDispatch()
  const [startDate, setStartDate] = useState(new Date());
  const device = useSelector(state => state.CommonConfig.device_type);
  const [selectGameName, setSelectGameName] = useState("0");
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  // const [gameName, setGameName] = useState([]);
  const [gameName, setGameName] = useState(gameList);
  const marketList = useSelector((state) => state.CommonConfig.marketList);
  const [referralBonusData, setReferralBonusData] = useState([]);
  const [referralbonusdatepopup, setReferralBonusPopup] = useState(false);
  const [referralbonusDateId, setReferralBonusDateId] = useState(null);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  const perPage = useSelector((state) => state.paginationData.dataInOnePage)
  const CustomInput = ({ value, onClick }) => (
    <div style={{ position: "relative" }} className="custom_calendar">
      <input
        type="text"
        value={value}
        onClick={onClick} // This opens the calendar on input click
        readOnly // Prevent direct text input
      />
      <button
        onClick={onClick} // This also opens the calendar on icon click

        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {/* <img src={CalendarIcon} alt="" /> */}
        <FaCalendar />
      </button>
    </div>
  );
  const openReferralBonusDatePopup = (turnoverDateId) => {
    setReferralBonusDateId(turnoverDateId);
    setReferralBonusPopup(true);
  };
  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };


  const sortedData = () => {

    let sortedArray = [];

    if (sortBy === "created_date") {
      sortedArray = referralBonusData.slice().sort((a, b) => {
        const aValue = new Date(a[sortBy]).getTime();
        const bValue = new Date(b[sortBy]).getTime();
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy === "turnover") {
      sortedArray = referralBonusData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy].replace(/,/g, ""));
        const bValue = parseFloat(b[sortBy].replace(/,/g, ""));
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy) {
      sortedArray = referralBonusData.slice().sort((a, b) => {
        const aValue = a[sortBy];
        const bValue = b[sortBy];
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else {
      sortedArray = referralBonusData.slice();
    }
    return sortedArray;
  };
  // api for Game list
  // const featchGameList = () => {
  //   makeAjax(url.TOGEL_API.listGame).then((response) => {
  //     if (response.status != respStatus["SUCCESS"]) {
  //       if (response.code != "validation_error") {
  //         showMessage(response);
  //         return;
  //       }
  //       showMessage(response);
  //       return;
  //     }
  //     setGameName(response.data);
  //   });
  // };

  // useEffect(() => {
  //   featchGameList();
  // }, []);

  // api for Referral Bonus list
  const fetchReferralBonus = () => {
    setLoading(true)
    let reqData = {
      page: pageNumber,
      length: perPage,
    };

    makeAjax(url.PLAYER_API.listReferralBonus, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code !== "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setReferralBonusData(response.data.data);
      dispatch(setTotalNoResult(response.data.total))

    });
    setLoading(false)
  };

  useEffect(() => {
    fetchReferralBonus();
    const container = document.querySelector('.table_container');
    if (container) {
      container.scrollTop = 0;
    }
  }, [perPage, sortBy, sortOrder, pageNumber]);

  const handleGameSelectOptions = (e) => {
    const selectedValue = e.target.value;
    setSelectGameName(selectedValue);
  };
  return (
    <div className='trasaction_popup'>

      <div className="trasaction_top_bar">
        <div className="calendar">
          <DatePicker
            // showIcon
            customInput={<CustomInput />}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
          />
        </div>
        <div className="all_game_dropdown">
          <select className="dropdown" onChange={handleGameSelectOptions}>
            <option value="0">All</option>
            {marketList.length > 0 &&
              marketList.map(({ game_id, game_name }) => (
                <option key={game_id} value={game_id}>
                  {game_name}
                </option>
              ))}
          </select>
        </div>
        <div className="search">
          <button  >{props.t('search')}</button>
        </div>

      </div>




      {/* table */}
      <div className={device === "Desktop" ? "informasi_tble_result" : "container"}>
        <table >
          <thead>
            <tr>
              <th onClick={() => handleSort("created_date")}>
                {props.t("register_date")}
                <span className="sorting_arrow">
                  {sortBy === "created_date" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("turnover")}>
                {props.t("turnover")}
                <span className="sorting_arrow">
                  {sortBy === "turnover" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>

              </th>
              <th onClick={() => handleSort("commission")}>
                {props.t("commision")}
                <span className="sorting_arrow">
                  {sortBy === "commision" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              sortedData().length === 0 ?
              <tr className="table_data_empty_row">
                <td colSpan="3">{props.t("data_not_found")}</td>
              </tr>
              :

              sortedData().map((item, index) => {
                return (

                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td
                      onClick={() =>
                        openReferralBonusDatePopup(item.created_date)
                      }
                    >
                      <p className="link">{item.created_date}</p>
                    </td>
                    <td>{formatPricewithdecimal(item.turnover)}</td>
                    {/* <td>{parseFloat(item.commission).toFixed(2)}</td> */}
                    <td>{formatPricewithdecimal(item.commission)}</td>

                  </tr>
                )
              })
            }
          </tbody>

        </table>
      </div>
    </div>
  )
}

export default withTranslation()(BonusReferral)
